import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as cl from "classnames"
import * as React from "react"
import Spinner from 'react-spinkit'
import * as Common from "./common"
import { Row } from "./table-definition"
import AccountYearForm from "../common/account-year-form-container"
import Popup from '../../ppi/ppi-detail/utils/popup'
import * as Model from "../../../model"
import * as AccountService from "../../../service/sfp/accounts-service-2"
import ConfimationModel from "./../common/ConfirmationModel"


export default class AccountYearEditor extends React.Component<Props, State> {
    constructor(props: Readonly<Props>) {
        super(props)
        this.state = {
            edit: false,
            submitting: false,
            showInduceds: false,
            comment: null,
            activeTab: 'account',
            position: 0,
            left: 0,
            confirm: false,
            title: null,
            checkvalue: "1",
            checked: false,
            id: null,
        }
    }

    private get induceds(): Induceds {
        const initial: Induceds = { items: [], total: 0 }
        if (!this.props.value.induceds) return initial

        return this.props.value.induceds.filter(o => o.project.visible == true).reduce<Induceds>((result, i) => {
            const induced = result.items.find(induced => i.project.name === induced.project)
            if (induced) {
                induced.total += i.gain - i.loss
            } else {
                initial.items.push({
                    project: i.project.name,
                    total: i.gain - i.loss
                })
            }
            result.total += i.gain - i.loss
            return result
        }, initial)
    }

    onCommentChange(event: React.ChangeEvent<HTMLInputElement>) {
        this.setState({ comment: event.target.value });
    }

    handleButtonClick(e) {
        e.preventDefault()
        const data = document.querySelector(".wtHolder").scrollTop
        const left = document.querySelector(".wtHolder").scrollLeft
        if (this.props.value.yearAccount && this.props.value.yearAccount.comment !== null) {
            this.setState({ comment: this.props.value.yearAccount.comment, edit: true, position: data, left: left })
        } else {
            this.setState({ edit: true, position: data, left: left })
        }
    }

    addSpace(nStr) {
        nStr += '';
        const x = nStr.split('.');
        let x1 = x[0];
        const x2 = x.length > 1 ? '.' + x[1] : '';
        var rgx = /(\d+)(\d{3})/;
        while (rgx.test(x1)) {
            x1 = x1.replace(rgx, '$1' + ' ' + '$2');
        }
        return x1 + x2;
    }

    render() {
        const className = cl("account-year-editor", {
            "has-value-percentile": this.props.value.yearAccount && this.props.value.yearAccount.percentile,
            "has-value-raw": this.props.value.yearAccount && !this.props.value.yearAccount.percentile
        })
        var gain = 0
        var loss = 0
        this.props.value.induceds.filter(o => o.project.visible == true).forEach(induced => {
            gain += induced.gain;
            loss += induced.loss;
        });
        const value = this.props.value.value
        var result;

        if (value == undefined)
            result = gain - loss;
        else if (this.props.value.induceds.length == 0)
            result = value;
        else
            result = value + this.getAmountHiddenInduceds();

        // const result = this.props.value.induceds.length == 0 ? value : (value == undefined) ? gain - loss : value
        return <div className={className}>
            <div className="account-year-actions">
                <div className="induceds-tick">
                    {this.renderShowInducedButton()}
                </div>

                {/* {!this.props.consulted &&
				<div className="edit-action">
					<button onClick={() => this.setState({ edit: true })}>
						<FontAwesomeIcon icon="chevron-down"/>
					</button>
				</div>} */}

                <div className="dummy" />
            </div>

            <div className="account-year-editor-value" onDoubleClick={(e) => this.handleButtonClick(e)}>
                {this.addSpace(Math.round(result))}
            </div>
            <div>
                {this.props.row.account.number !== "66111" &&
                    <button className="account-year-editor-value" onClick={(e) => this.handleButtonClick(e)}>
                        {(this.props.value.yearAccount && this.props.value.yearAccount.comment !== null && this.props.value.yearAccount.comment !== '') ?
                            <FontAwesomeIcon title={this.props.value.yearAccount.comment} icon='star' /> :
                            <FontAwesomeIcon icon='plus-square' />}
                    </button>}
            </div>
            {/* {this.state.submitting &&
			<Spinner fadeIn="none" name="wave" color="#3d3c3f"/>} */}

            {this.state.edit &&
                <Popup
                    onHide={() => this.handleCancelEdit()}
                    title={this.state.activeTab === 'account' ? "Mise à jour de la valeur" : "Mise à jour du commentaire"}>
                    <div className="edit-box-content">
                        <div>
                            <p className="label">{this.props.row.account.number} - {this.props.row.account.label}</p>
                        </div>
                        <br />
                        <ul className="tabHeader">
                            <li className={this.state.activeTab === 'account' ? 'active' : ''}
                                onClick={() => this.setState({ activeTab: 'account' })}>
                                Valeur
                            </li>
                            <li className={this.state.activeTab === 'comment' ? 'active' : ''}
                                onClick={() => this.setState({ activeTab: 'comment' })}>
                                Commentaire
                            </li>
                        </ul>
                        <div className="tabsBody">
                            {this.state.activeTab === 'account' && <div className="tab1">
                                <AccountYearForm
                                    account={this.props.row.account}
                                    type={this.props.row.type}
                                    submitting={this.state.submitting}
                                    induceds={this.props.value.induceds}
                                    value={this.props.value}
                                    amount={this.props.row.amount}
                                    onCancelEdit={() => this.handleCancelEdit()}
                                    onSubmit={(a, p) => this.handleSubmit(a, p)}
                                    onDelete={() => this.handleDelete()} />
                            </div>}
                            {this.state.activeTab === 'comment' && <div className="tab2">
                                {/* <div>
								<label>commentaire</label>
								<div className="formField">
									<input type="text" defaultValue={this.state.comment}/>
								</div>
							</div> */}
                                <div className="columns is-desktop">
                                    <div className="column">
                                        <p className="field">
                                            {this.props.value.yearAccount && this.props.value.yearAccount.id ?
                                                <span className="field is-horizontal">
                                                    <span className="field-label is-normal">
                                                        <label className="label">Commentaire</label>
                                                    </span>
                                                    <span className="field-body">
                                                        <span className="field">
                                                            <span className="control">
                                                                <input type="text" className="input"
                                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>): void => this.onCommentChange(e)}
                                                                    value={this.state.comment} />
                                                            </span>
                                                        </span>
                                                    </span>
                                                </span>
                                                : <span>Une valeur ou un pourcentage doit être associé à la cellule pour pouvoir ajouter un commentaire</span>}
                                        </p>
                                    </div>
                                </div>
                                {this.props.value.yearAccount && this.props.value.yearAccount.id &&
                                    <div className="modalFoter">
                                        <button onClick={() => this.postComment(this.props.value.yearAccount.id)}
                                            className="button is-primary ">Mettre à jour
                                        </button>
                                        <button onClick={() => this.deleteComment(this.props.value.yearAccount.id)}
                                            className="button is-secondary ">Supprimer le commentaire
                                        </button>
                                    </div>}
                            </div>}

                        </div>

                    </div>
                    {/* <div className="edit-box-content">
					<AccountYearForm
					account={this.props.row.account}
					type={this.props.row.type}
					induceds={this.props.value.induceds}
					value={this.props.value}
					amount={this.props.row.amount}
					onCancelEdit={() => this.handleCancelEdit()}
					onSubmit={(a, p) => this.handleSubmit(a, p)}
					onDelete={() => this.handleDelete()}/>
				</div> */}
                </Popup>}

            {this.state.showInduceds &&
                <Popup
                    onHide={() => this.setState({ showInduceds: false })}
                    title={(this.props.row.type == "revenues" ? "Recettes" : "Charges") + " induites"}>
                    <div className="scenario-account-year-induceds">
                        <div className="induceds-list">
                            {this.induceds.items.map((induced, index) =>
                                <div className="induced-detail" key={index}>
                                    <span className="induced-project">{induced.project}</span>
                                    <span className="induced-amount">{induced.total}</span> €
                                </div>)}

                            <div className="induced-detail total-induceds">
                                <span className="induced-project">
                                    <strong>
                                        Total des {this.props.type == "revenues" ? "recettes" : "charges"}
                                    </strong>
                                </span>

                                <span className="induced-amount">{this.induceds.total} €</span>
                            </div>
                        </div>
                    </div>
                </Popup>}
            {this.state.confirm &&
                <Popup
                    onHide={() => this.handleHideModel()}
                    title={this.state.title}>
                    <ConfimationModel
                        submitting={this.state.submitting}
                        onChange={this.handleCheckType}
                        confirm={this.state.checked}
                        handleConfirm={this.handleConfirm}
                    />
                </Popup>
            }
        </div>
    }

    handleHideModel = () => {
        this.setState({ confirm: false })
    }

    handleConfirm = (e, value) => {
        e.preventDefault()
        this.setState({ confirm: false })
        if (value == "1") {
            if (this.state.title == "Ajouter") {
                AccountService.updateScenarioComment(this.state.id, this.state.comment).then((response) => {
                    this.props.onChange("account_comment", response)
                    this.setState({ comment: null, edit: false })
                })
            } else if (this.state.title == "Effacer") {
                AccountService.updateScenarioComment(this.state.id, "").then((response) => {
                    this.props.onChange("account_comment", response)
                    this.setState({ comment: null, edit: false })
                })
            }
        } else {
            this.handleHideModel()
            this.handleCancelEdit()
        }
    }

    handleCheckType = (e) => {
        this.setState({ checked: (e.target.value == "1" ? false : true), checkvalue: e.target.value })
    }

    private postComment(id) {
        if (this.state.comment !== null) {
            this.setState({ confirm: true, title: "Ajouter", id: id })
        }
    }

    private deleteComment(id) {
        if (this.state.comment !== null) {
            this.setState({ confirm: true, title: "Effacer", id: id })
        }
    }

    private handleCancelEdit() {
        this.setState({ edit: false })
    }

    private handleDelete() {
        this.setState({ submitting: true })
        const year = this.props.scenario.year + this.props.col - 7
        this.props.onChange("account_year", {
            account: this.props.row.account,
            chapter: this.props.row.chapter,
            amount: null,
            percentile: null,
            year,
            postion: { top: this.state.position, left: this.state.left }
        })
        this.setState({ submitting: true }, () => {
            setTimeout(() => {
                this.setState({ edit: false, submitting: false })
            }, 1200)
        })
    }

    private handleSubmit(amount: number, percentile: boolean) {
        const year = this.props.scenario.year + this.props.col - 7
        this.props.onChange("account_year", {
            account: this.props.row.account,
            chapter: this.props.row.chapter,
            amount,
            percentile,
            year,
            postion: { top: this.state.position, left: this.state.left }
        })
        this.setState({ submitting: true }, () => {
            setTimeout(() => {
                this.setState({ edit: false, submitting: false })
            }, 1200)
        })

    }

    private renderShowInducedButton(): React.ReactNode {
        if (this.props.value.induceds && this.props.value.induceds.filter(induce => induce.project.visible == true).length) {
            return <div
                className="account-year-induceds"
                onClick={() => this.setState({ showInduceds: true })}>
                {this.props.value.induceds.filter(induce => induce.project.visible == true).length}
            </div>
        }
    }

    private getAmountHiddenInduceds(): number {
        var result = 0;
        if (this.props.value.induceds.length) {
            const hiddenInduceds = this.props.value.induceds.filter(o => o.project.visible == false);
            if (hiddenInduceds.length) {
                hiddenInduceds.forEach(induced => {
                    if (induced.gain)
                        result -= induced.gain;
                    if (induced.loss)
                        result += induced.loss;
                });
            }
        }
        return result;
    }
}

interface Induced {
    project: string;
    total: number;
}

interface Induceds {
    items: Induced[];
    total: number;
}

interface Props {
    col: number;
    consulted: boolean;
    row: Row;
    scenario: Model.Scenario;
    type: string;
    value: Common.Value;

    onChange(type: "account_year", data): void;

    onChange(type: "account_comment", data: Common.AccountYearChangeData): void
}

interface State {
    edit: boolean;
    submitting: boolean;
    showInduceds: boolean;
    comment: string;
    activeTab: string;
    position: number;
    left: number;
    confirm: boolean;
    title: string;
    checkvalue: string;
    checked: boolean;
    id: any;
}



// WEBPACK FOOTER //
// ./src/component/scenarii/detail/account-year-editor.tsx